import { render } from "./ImagePreviewModal.vue?vue&type=template&id=979b7afc&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js"

import "./ImagePreviewModal.scss?vue&type=style&index=0&id=979b7afc&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979b7afc"]])

export default __exports__